// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"19493d5a","481":"e53125cf","995":"e43dbfef"}[chunkId] + ".chunk.js";
};